import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';

import Hero from './sections/Hero'
import ThreeCards from './sections/ThreeCards'
import FourLinks from './sections/FourLinks'
import FourCards from './sections/FourCards'
import FourImages from './sections/FourImages'

import ImageGallery from './sections/ImageGallery'
import Quote from './sections/Quote'
import Footer from './Footer'

import { HOME_PAGE_QUERY } from '../context/context'
import { useContentfulEntry } from '../hooks/useContentfulEntry'

function Home() {
  const { entry: homeResponse, loading, error } = useContentfulEntry(HOME_PAGE_QUERY);
  const [sections, setSections] = useState(null);

  useEffect(() => {
    if (homeResponse && homeResponse.items && homeResponse.includes) {
      const mainEntry = homeResponse.items[0];
      const includes = homeResponse.includes.Entry;

      // Resolve sections
      const resolvedSections = mainEntry.fields.sections.map(section => {
        return includes.find(item => item.sys.id === section.sys.id) || section;
      });

      setSections(resolvedSections);
    }
  }, [homeResponse]);

  if (loading) return <div>Loading home page...</div>;
  if (error) return <div>Error loading home page.</div>;
  if (!sections) return null;

  return (
    <Container fluid>
      <Row>
        {sections.map((section, index) => {
          if (!section || !section.fields) return null;
          switch (section.fields.type) {
            case 'Hero':
              return <Hero section={section} minHeight={500} zIndex={index} key={index} />
            case 'Three Cards':
              return <ThreeCards section={section} zIndex={index} key={index} />
            case 'Four Links':
              return <FourLinks section={section} zIndex={index} key={index} />
            case 'Four Cards':
              return <FourCards section={section} zIndex={index} key={index} />
            case 'Four Images':
              return <FourImages section={section} zIndex={index} key={index} />
            case 'Map':
              return null
            case 'Image Gallery':
              return <ImageGallery section={section} key={index} />
            case 'Quote':
              return <Quote section={section} key={index} />
            default:
              return null
          }
        })}
      </Row>
      <Row>
        <Footer />
      </Row>
    </Container>
  );
}

export default Home;
